import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { OnlineContentTypes, OnlineStripContent } from 'src/app/models';
import { StripComponent, StripInfoboxesComponent } from '../../components';
import { StripImageComponent } from '../../components/strip-image/strip-image.component';

@Component({
  selector: 'app-strip-container',
  templateUrl: './strip-container.component.html',
  styleUrls: ['./strip-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [StripComponent, StripInfoboxesComponent, StripImageComponent],
})
export class StripContainerComponent {
  types = OnlineContentTypes;
  @Input() strips: OnlineStripContent[];
}
